<section class="lesson-list" [attr.aria-label]="'app.parentLearning.lessons.title' | translate">
  <header class="lesson-list__header">
    <h2 class="lesson-list__title">
      {{ 'app.parentLearning.lessons.title' | translate }}
    </h2>
    <p class="lesson-list__hint">
      {{ 'app.parentLearning.lessons.hint' | translate }}
    </p>
  </header>

  @if (sortedLessons().length === 0) {
    <p class="lesson-list__empty">
      {{ 'app.parentLearning.lessons.empty' | translate }}
    </p>
  } @else {
    <ol class="lesson-list__items">
      @for (lesson of sortedLessons(); track lesson.id; let i = $index) {
        <li>
          <button
            type="button"
            class="lesson-list__item"
            [class.lesson-list__item--locked]="lesson.isLocked"
            [class.lesson-list__item--done]="lesson.isCompleted"
            [class.lesson-list__item--active]="lesson.id === selectedLessonId()"
            [class.lesson-list__item--unlocking]="lesson.id === newlyUnlockedId()"
            [disabled]="disabled() || lesson.isLocked"
            [attr.aria-current]="lesson.id === selectedLessonId() ? 'step' : null"
            (click)="onLessonClick(lesson)"
          >
            <span class="lesson-list__index" aria-hidden="true">{{ i + 1 }}</span>
            <span class="lesson-list__body">
              <span class="lesson-list__name">{{ lesson.title }}</span>
              @if (lesson.estimatedTime > 0) {
                <span class="lesson-list__meta">
                  {{
                    'app.parentLearning.lessons.duration'
                      | translate: { minutes: lesson.estimatedTime }
                  }}
                </span>
              }
            </span>
            <span class="lesson-list__status" [attr.data-status]="lessonStatus(lesson)">
              @switch (lessonStatus(lesson)) {
                @case ('locked') {
                  {{ 'app.parentLearning.lessons.locked' | translate }}
                }
                @case ('done') {
                  {{ 'app.parentLearning.lessons.completed' | translate }}
                }
                @case ('active') {
                  {{ 'app.parentLearning.lessons.inProgress' | translate }}
                }
                @default {
                  {{ 'app.parentLearning.lessons.start' | translate }}
                }
              }
            </span>
          </button>
        </li>
      }
    </ol>
  }
</section>
